<app-modal-confirmation>
  <ng-template appCustomModalHeader>
    <div class="modal-header">
      <h4 class="fs-lg-u7 fs-u3 fw-bold mb-0 mx-2">
        @if (headerIconPath) {
          <span class="me-2">
            <svg
              alt="Check Circle"
              height="24"
              width="24"
              viewBox="0 0 16 16"
              [style.color]="'rgb(23, 80, 192)'"
            >
              <circle
                cx="50%"
                cy="50%"
                r="50%"
                [attr.fill]="'#e8eefb'"
              />
              <use
                height="12"
                width="12"
                x="2"
                y="2"
                stroke="currentColor"
                [attr.href]="headerIconPath"
              ></use>
            </svg>
          </span>
        }
        {{ header || 'COMMON.Confirm' | translate }}
      </h4>
      @if (!headerCloseButton) {
        <button
          aria-label="Close"
          class="btn btn-std-outline-black-light btn-icon mx-3"
          type="button"
          (click)="onDismissClick()"
        >
          <span class="far fa-times fa-lg"></span>
        </button>
      }
    </div>
  </ng-template>
  <ng-template appCustomModalBody>
    <div
      class="modal-body"
      [ngClass]="
        (bodyNotDesignDownload ? 'p-4' : 'p-3 p-lg-4 mt-3') +
        ' ' +
        bodyCustomClass
      "
    >
      <div
        [ngClass]="{
          'd-flex flex-column align-items-center justify-content-center w-100':
            !bodyNotDesignDownload,
        }"
      >
        @if (imageRef) {
          <div
            [ngClass]="{
              'mb-3 mb-lg-4':
                !bodyNotDesignDownload && showSubmitButton,
            }"
          >
            <ng-container
              [ngTemplateOutlet]="imageRef"
            ></ng-container>
          </div>
        }
        @if (!bodyNotDesignDownload) {
          <label class="fs-u1 fs-lg-u2 fw-md-medium text-center mb-1"
            >{{ title }}
          </label>
        }
        @if (!bodyNotDesignDownload && titleSecondLine) {
          <label class="fs-u1 fs-lg-u2 fw-md-medium text-center mb-1"
            >{{ titleSecondLine }}
          </label>
        }
        @if (!bodyNotDesignDownload) {
          <label
            class="fs-l2 fw-normal text-center text-gray-neutrals mb-0"
            >{{ subtitle }}
          </label>
        }
        @if (!bodyNotDesignDownload && subtitleSecondLine) {
          <label
            class="fs-l2 fw-normal text-center text-gray-neutrals mb-0"
            [ngClass]="subtitleSecondLineCustomClass"
          >
            {{ subtitleSecondLine }}
          </label>
        }
        @if (showDismissButton || showSubmitButton) {
          <div
            class="d-flex align-items-center"
            [ngClass]="actionBtnContainerClass"
          >
            @if (showDismissButton) {
              <button
                class="btn btn-std btn-std-outline fs-base-l4 mx-1 fw-semibold justify-content-center"
                type="button"
                [disabled]="isLoading"
                (click)="onDismissClick()"
              >
                {{ dismissText }}
              </button>
            }
            @if (showSubmitButton) {
              <button
                class="btn btn-std btn-std-prim fs-base-l4 mx-1 py-base-l8"
                type="button"
                [disabled]="isSubmitDisabled || disabled"
                [ladda]="isLoading"
                (click)="onSubmitClick()"
              >
                {{ submitText }}
              </button>
            }
          </div>
        }
      </div>
    </div>
  </ng-template>
  <ng-template appCustomModalFooter></ng-template>
</app-modal-confirmation>
